module.exports = __webpack_public_path__ + "static/media/intraday_bullish.2d252e35.svg";